import { render, staticRenderFns } from "./SliderInputForm.vue?vue&type=template&id=151505f4"
import script from "./SliderInputForm.vue?vue&type=script&lang=js"
export * from "./SliderInputForm.vue?vue&type=script&lang=js"
import style0 from "./SliderInputForm.vue?vue&type=style&index=0&id=151505f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports